<template>
<div class="taskPdf">
    <div class="one-page">
        <img src="http://cdn.edstatic.com/203012120000/c7ad71af39a1d…/2021/09/0ff84550-968c-436d-9d15-248ea8a240c5.png"/>
        <div class="name">
            <span>郭伟</span>
            <span class="page">Page1/3</span>
        </div>
        <div class="schedule">
            <div class="date">2021年10月21日</div>
            <div class="main">
                <div>会场一</div>
                <div class="time">07:00-07:05</div>
                <div class="content">
                    <span>就是写个主题</span>
                    <span>-这里是讲题</span>
                    <p>这里是任务主持讲者之类的</p>
                    <p>这里是zoom_id</p>
                </div>
            </div>
            <div class="date"></div>
        </div>
    </div>
    <div class="one-page">
        <img :src="session.top_image"/>
        <div class="name">
            <span>郭伟</span>
            <span class="page">Page2/3</span>
        </div>
        <div class="schedule">
            <div class="date">2021年10月21日</div>
            <div class="main">
                <div>会场一</div>
                <div class="time">07:00-07:05</div>
                <div class="content">
                    <span>就是写个主题</span>
                    <span>-这里是讲题</span>
                    <p>这里是任务主持讲者之类的</p>
                    <p>这里是zoom_id</p>
                </div>
            </div>
            <div class="date"></div>
        </div>
    </div>
    <div class="one-page">
        <img :src="session.top_image"/>
        <div class="name">
            <span>郭伟</span>
            <span class="page">Page3/3</span>
        </div>
        <div class="schedule">
            <div class="date">2021年10月21日</div>
            <div class="main">
                <div>会场一</div>
                <div class="time">07:00-07:05</div>
                <div class="content">
                    <span>就是写个主题</span>
                    <span>-这里是讲题</span>
                    <p>这里是任务主持讲者之类的</p>
                    <p>这里是zoom_id</p>
                </div>
            </div>
            <div class="date"></div>
        </div>
    </div>
</div>
</template>
<script>
	import {TaskBookDetail,PersoanalUserInfo} from '../../../config/interface.js'
	export default{
		data(){
			return{
                htmlTitle:'',
				userInfo:'',  //用户信息
                session:{},
                schedule:{},
                meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
                loading:true,
                timeList:[] //时间列表 判断是否有重合
			}
		},
        created(){

        },
		mounted(){



		},
		methods:{
           //获取信息
			getMeetingSchedule(){
				const url=TaskBookDetail;
				const method='POST'
				let params={
                    writer_id:this.userInfo.writer_id,
                    meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id
                };
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						
					}
                    else{
                        common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{

                        })
                    }
				})
			},
            format(str){
                if(str){
                    str=str.replace(/(\r\n|\n|\r)/gm, "<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;");
                    str="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"+str;
                }
                return str;
            },
            loadImage(){
                this.loading=false;
            },
            //判断该表中是否有重合的时间 有重合的标红
            if_red(arr){
                for(let i=0;i<arr.length;i++){
                    for(let j=i+1;j<arr.length;j++){
                        if(this.overlap(arr[i].start_time,arr[i].end_time,arr[j].start_time,arr[j].end_time)&&j!=i){
                            arr[i].if_red=true;
                            arr[j].if_red=true;
                        }
                    }

                }
            },
            //判断两个时间是否重合
            overlap(time1_start,time1_end,time2_start,time2_end){
                let date1=new Date(time1_start);
                let date2=new Date(time1_end);
                let date3=new Date(time2_start);
                let date4=new Date(time2_end);
                if(date2>date3&&date2<date4){
                    return true; //返回true有重合
                }
                if(date2>=date4&&date1<=date3){
                    return true; //返回true有重合
                }
                if(date3>date1&&date3<date2){
                    return true; //返回true有重合
                }
                if(date3<=date1&&date4>=date2){
                    return true; //返回true有重合
                }
                return false;
            }

		}
	}
</script>
<style lang="scss">
.all{
    background-size:contain ;
    
}
.top-image{
    width:100%;
}
.transfer-image{
        width:100%
    }
.book-detail{
    padding:0 10px;
    .header{
        height:70px;
        img{
           width:100%;
            
        }
    }
    .content{
        .title{
            text-align: center;
            color: white;
            font-size:14px;
        }
        .subtitle{
            margin: 20px 0;
            color: white;
            // display: flex;
            // height: 120px;
            // align-items: center;
            text-align: center;
            display: flex;
            justify-content: center;
            div{
                width: 30%;
            }
            img{
                width:60px;
                height: 60px;
                // background: black;
                border:none;

            }
            span{
                
                font-size:25px;
                height:60px;
                line-height: 60px;
                color: white;
                
            }
        }
        .text{
            padding:0 10px 10px 10px;
            p{
                color: white;
                font-size:12px;
                line-height: 26px;
                b{
                    font-size:14px;
                }
            }
        }
        table{
            text-align: center;
            border: 1px solid rgb(209, 196, 196);
            border-collapse: collapse;
            word-break:break-all;
            th{
                background: rgb(243, 217, 217);
                font-size:12px;
                color: brown;
                // width:16.67%;
                border: 1px solid rgb(209, 196, 196);
            }
            tr{
                font-size:12px;
                background: white;
                border: 1px solid rgb(209, 196, 196);
                td{
                    border: 1px solid rgb(209, 196, 196);
                }
            }
        }

    }
    .tip{
            padding: 10px 0;
            color:white;
            word-break:break-all;
            line-height: 20px;
        }
    .qrcode{
        color: white;
        font-size:12px;
        height: 150px;
        margin:10px 10px  0px 10px;
        .bottom-qrcode{
            float:right;
            width:90px;
            img{
            width:90px;
            height:90px;
            }
            p{
            text-align: center;
            }

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/TaskBook/TaskPdf.vue